// extracted by mini-css-extract-plugin
module.exports = {"mWipe":"PageTransitions_mWipe__DhmCI","oComponent":"PageTransitions_oComponent__3QOY_"};